import request from "./request";
import { ENDPOINTS } from "./apiRoutes";
import queryString from "query-string";
function get(url, isTokenNeeded = true, params = null) {
  if (params) {
    const urlParams = queryString.stringify(params, {
      encode: false,
      //arrayFormat: "bracket",
    });
    url = `${url}?${urlParams}`;
  }
  return request(
    {
      url,
      method: "GET",
      crossDomain: true,
    },
    isTokenNeeded
  );
}

function post(url, body, isTokenNeeded = true) {
  return request(
    {
      url,
      method: "POST",
      data: body,
      crossDomain: true,
    },
    isTokenNeeded
  );
}

function download(url, body, isTokenNeeded = true) {
  return request(
    {
      url,
      method: "GET",
      responseType: "blob",
      data: body,
      crossDomain: true,
    },
    isTokenNeeded
  );
}

function uploadFile(url, body, isTokenNeeded = true) {
  return request(
    {
      url,
      method: "POST",
      data: body,
      crossDomain: true,
    },
    isTokenNeeded,
    {
      "Content-Type": "multipart/form-data",
    }
  );
}

function put(url, body, isTokenNeeded = true) {
  return request(
    {
      url,
      method: "PUT",
      data: body,
    },
    isTokenNeeded
  );
}

function deleteResource(url, body, isTokenNeeded = true) {
  return request(
    {
      url,
      method: "DELETE",
      data: body,
      crossDomain: true,
    },
    isTokenNeeded
  );
}

function patch(url, body, isTokenNeeded = true, isMultipart = false) {
  let customHeaders = null;
  if (isMultipart) {
    customHeaders = {
      "Content-Type": "multipart/form-data",
    };
  }
  return request(
    {
      url,
      method: "PATCH",
      data: body,
      crossDomain: true,
    },
    isTokenNeeded,
    customHeaders
  );
}

const API = {
  get,
  post,
  put,
  patch,
  download,
  deleteResource,
  uploadFile,
};

export { API, ENDPOINTS };
